import React, { Component } from 'react';
import MineralUiTabs, { Tab as MineralUiTab } from 'mineral-ui/Tabs';

// Wrapper for MineralUi grid components
// https://mineral-ui.com/components/flex

export default class Tabs extends Component {
  static Tab = MineralUiTab;

  render() {
    return <MineralUiTabs {...this.props} />;
  }
}
